// Vuetify 2 positions v-menu content once on open and only recalculates on window resize,
// so dropdowns inside dialogs that scroll their own body stay frozen in place.
export default function closeMenusOnScroll () {
  window.addEventListener('scroll', (event) => {
    if (!document.querySelector('.menuable__content__active')) return

    const target = event.target

    document.querySelectorAll('.v-menu').forEach((el) => {
      const menu = el.__vue__
      if (!menu || !menu.isActive) return

      // Scrolling the option list itself must not close the menu
      const content = menu.$refs && menu.$refs.content
      if (content && content.contains(target)) return

      menu.isActive = false
    })
  }, true)
}